import { render } from "./NewDocumentGeneration.vue?vue&type=template&id=243e2264&scoped=true"
import script from "./NewDocumentGeneration.vue?vue&type=script&lang=js"
export * from "./NewDocumentGeneration.vue?vue&type=script&lang=js"

import "./NewDocumentGeneration.vue?vue&type=style&index=0&id=243e2264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e2264"]])

export default __exports__